import { colord } from 'colord';
import { Colors, ColorValue } from '@zapier/design-system';
import {
  ZapCardSection as ZapCardSectionZDS,
  ZapCardSectionProps,
} from '@zapier/design-system-patterns';
import { Section } from '../../Section/Section';
import { BackgroundColorKeys } from '../../Section/background';
import {
  CtaGoalType,
  CtaNameType,
  CTAType,
  EventName,
  SectionName,
  useTrackEvent,
  useAvroTracking,
} from '../../../observability';

type Item = ZapCardSectionProps['items'][0] & {
  ctaGoal: CtaGoalType;
  ctaName: CtaNameType;
};

type Props = {
  background?: BackgroundColorKeys;
  items: Item[];
};

export function ZapCardSection({ background, items }: Props) {
  return (
    <Section
      background={background}
      sectionToTrack={SectionName.ZapCardSection}
    >
      <ZapCards items={items} />
    </Section>
  );
}
// Have to create an inner component in order for useTrackEvent to be invoked in TrackingProvider
function ZapCards({ items }: Props) {
  const trackEvent = useTrackEvent();
  const { emitCTAClickEvent } = useAvroTracking();

  const zapCardItems = items.map((item, index) => ({
    ...item,
    color: item.color
      ? (colord(item.color).toHex() as ColorValue)
      : Colors.white,
    key: `zap_card_${index}`,
    onClick: () => {
      emitCTAClickEvent({
        text: item.title,
        href: item.href,
        section: SectionName.ZapCardSection,
        type: CTAType.zap_card_link,
      });
      trackEvent(EventName.CALL_TO_ACTION, {
        path: window.location.pathname,
        from_path: document.referrer,
        cta_name: item.ctaName,
        cta_goal: item.ctaGoal,
        cta_raw_text: item.title,
        link_destination: item.href,
      });
    },
  }));
  return <ZapCardSectionZDS items={zapCardItems} />;
}
